export default {
      id: "icon-promothin-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons.svg#icon-promothin",
      toString: function () {
        return this.url;
      }
    }